import { Component } from '@angular/core';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { TranslateService } from '@ngx-translate/core';
import { ViewWillEnter, ViewWillLeave } from '@ionic/angular';
import { PATHS } from '@shared/constants/paths';
import { environment } from '../../../../../environments/environment';
import { BrowseHierarchyFacadeService } from '@usf/ngrx-product';
import { Observable, Subscription } from 'rxjs';
import { PageTitle } from '@shared/constants/page-titles.enum';
import { ProductClass } from '@usf/product-types';
import { ToggleNewSearchService } from '@shared/services/toggle-new-search/toggle-new-search.service';

@Component({
  selector: 'app-browse-categories',
  templateUrl: './browse-categories.page.html',
  styleUrls: ['./browse-categories.page.scss'],
})
export class BrowseCategoriesPage implements ViewWillEnter, ViewWillLeave {
  productClass: ProductClass[];
  browseHierarchyViewModel$: Subscription;
  baseCategoryImageUri = `${environment.mediaServerUrl}/`;
  searchPath = '/' + PATHS.SEARCH;
  newSearchPath = '/' + PATHS.NEW_SEARCH;

  newSearchEnabled$: Observable<boolean>;

  constructor(
    readonly platformService: PlatformService,
    private translateService: TranslateService,
    protected panAppState: PanAppState,
    private browseHierarchyFacadeService: BrowseHierarchyFacadeService,
    private readonly toggleNewSearchService: ToggleNewSearchService,
  ) {}

  ionViewWillEnter(): void {
    this.panAppState.setPageTitle(
      this.translateService.instant(PageTitle.browseProductCategoriesPage),
    );
    this.browseHierarchyFacadeService.loadBrowseCategories();
    this.browseHierarchyViewModel$ = this.browseHierarchyFacadeService
      .getBrowseHierarchyViewModel()
      .subscribe(value => {
        this.productClass = value.categories.sort((a, b) =>
          a.classDescription.localeCompare(b.classDescription),
        );
      });

    this.newSearchEnabled$ =
      this.toggleNewSearchService.newSearchEnabledObservable$;
  }

  ionViewWillLeave(): void {
    this.browseHierarchyViewModel$.unsubscribe();
  }
}
